'use client';

import { ChakraProvider, createSystem, defaultConfig } from '@chakra-ui/react';
import { ColorModeProvider, type ColorModeProviderProps } from './color-mode';
import { config } from './theme';

export function Provider(props: ColorModeProviderProps) {
	return (
		<ChakraProvider value={createSystem(defaultConfig, config)}>
			<ColorModeProvider {...props} />
		</ChakraProvider>
	);
}
